import { render, staticRenderFns } from "./SideBarChart.vue?vue&type=template&id=96fc4e72&"
import script from "./SideBarChart.vue?vue&type=script&lang=js&"
export * from "./SideBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports